// extracted by mini-css-extract-plugin
module.exports = {"root":"root___37fMQ","detailRoot":"detailRoot___1hWAJ","prewrapDiv":"prewrapDiv___3EnS7","webDetailRoot":"webDetailRoot___1KcXF","baseTitleContainer":"baseTitleContainer___2mfbs"};